"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSirenValid = exports.isPhoneValid = exports.isEmailValid = exports.default = void 0;
var _core = require("./core");
var _default = exports.default = {
  getParameterByName(name) {
    let url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
};
const isEmailValid = (email, t) => {
  const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
  if (!emailPattern.test(email)) {
    _core._Notifications.warning(t('common_form_warning_title'), t('common_form_warning_email_wrong_format'));
    return false;
  }
  return true;
};
exports.isEmailValid = isEmailValid;
const isPhoneValid = (phone, t) => {
  const phonePattern = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
  if (!phonePattern.test(phone)) {
    _core._Notifications.warning(t('common_form_warning_title'), t('common_form_warning_phone_wrong_format'));
    return false;
  }
  return true;
};
exports.isPhoneValid = isPhoneValid;
const isSirenValid = (siret, t) => {
  if (!siret) return true;
  const sirenPattern = /^(\d{14})$/;
  if (!sirenPattern.test(siret)) {
    _core._Notifications.warning(t('common_form_warning_title'), t('common_form_warning_siret_wrong_format'));
    return false;
  }
  return true;
};
exports.isSirenValid = isSirenValid;